@if (hasLink()) {
    <a
        class="grid-cell-text__content"
        [class.dx-link]="useDxLinkStyle()"
        [routerLink]="link()!.routerLink"
        [queryParams]="link()!.queryParams ?? null"
        [title]="tooltip()"
        (click)="onLinkClick($event)"
    >
        {{ displayText() }}
    </a>
} @else {
    <span class="grid-cell-text__content" [title]="tooltip()">{{ displayText() }}</span>
}
